<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <Loader :loading="httpSend">
          
          <div v-if="guias && guias.length > 0">
            <!-- Header do Detalhe as a premium card -->
            <div class="table-card p-4 mb-section">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="m-0 font-weight-bold text-dark"><i class="bx bx-receipt mr-1"></i> DUAM: {{ guias[0].dam_codigo_v }}</h6>
                  <p class="text-muted mb-0 mt-1 font-size-13">Lista das Notas Fiscais Tributadas associadas a esta guia</p>
                </div>
                <div>
                  <button v-show="guias[0].tab_106situacao ==='963' || guias[0].tab_106situacao ==='964'"
                        type="button"
                        @click="baixarGuia" class="btn btn-primary shadow-none font-weight-medium px-4">
                    <i class="bx bx-download label-icon"></i> Baixar DUAM
                  </button>
                </div>
              </div>
            </div>

            <!-- Tabela de Notas associadas -->
            <div class="table-card mb-section">
              <div class="table-header">
                <div class="header-left-group">
                  <p class="chart-title"><i class="bx bx-list-ul mr-1 text-primary"></i> Notas Fiscais Tributadas</p>
                  <span class="badge-count">{{ guias.length }} registros</span>
                </div>
              </div>
              <div class="table-wrapper">
                <table class="nf-table row-border-bottom">
                  <thead>
                    <tr>
                      <th>N° da Nota</th>
                      <th>Tomador</th>
                      <th>Competência</th>
                      <th class="td-right">Valor da Nota</th>
                      <th class="td-right">Valor ISS</th>
                      <th class="td-right">IR</th>
                      <th class="th-status">Retido</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="g in guias" :key="g.sep_codigo" :class="{ 'row--cancelada': g.soc_codigo }">
                      <td class="td-mono td-bold">
                         <router-link tag="a" target="_blank" class="text-primary text-decoration-none" :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.not_hash}}">
                        {{ g.not_numero || '-' }}
                </router-link>
                        <span v-show="g.soc_codigo" class="status-badge status-badge--cancelada ml-2">Cancelada</span>
                      </td>
                      <td>
                        <span class="text-truncate d-inline-block" style="max-width: 250px;">{{ g.sep_razao_social_tomador }}</span><br>
                        <span class="text-muted font-size-11 td-mono" v-if="g.sep_cpf_cnpj_tomador.length < 12">{{ g.sep_cpf_cnpj_tomador | VMask('###.###.###-##') }}</span>
                        <span class="text-muted font-size-11 td-mono" v-else>{{ g.sep_cpf_cnpj_tomador | VMask('##.###.###/####-##') }}</span>
                      </td>
                      <td>{{ g.sep_competencia | formatDateCompetencia }}</td>
                      <td class="td-mono td-right" style="white-space: nowrap;">{{ g.sep_valor | formatNumeroBr }}</td>
                      <td class="td-mono td-right" style="white-space: nowrap; font-weight: 500;">{{ g.sep_iss | formatNumeroBr }}</td>
                      <td class="td-mono td-right" style="white-space: nowrap;">{{ g.sep_ir | formatNumeroBr }}</td>
                      <td>
                        <span class="status-badge status-badge--info">{{ g.sep_iss_retido | s_NtoText }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </Loader>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import Loader from "@/components/widgets/loader";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {guiaDetalhe} from "@/api/financeiro/guia";
import {impressao} from "@/helps/impressao";
import {getFinanceiroGuia} from "@/api/relatorio/financeiro";

export default {
  page: {
    title: "DUAM Detalhe",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader
  },
  data() {
    return {
      title: "DUAM Detalhe",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'DUAM',
          active: true,
        },
      ],
      httpSend: false,
      guias: [],
    };
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  created() {
    this.getGuia();
  },
  methods: {
    getGuia() {
      this.httpSend = true;
      guiaDetalhe(this.$route.params.dam_hash).then(response => {
        if (response.status) {
          this.guias = response.dados;
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    baixarGuia() {
      this.httpSend = true;
      impressao(getFinanceiroGuia(this.$route.params.dam_hash), 'P').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
};
</script>



<style scoped>
.mb-section { margin-bottom: 12px; }

.table-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.table-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #f1f5f9;
  display: flex; align-items: center; justify-content: space-between;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.chart-title { margin: 0; font-size: 14px; font-weight: 600; color: #1e293b; display: flex; align-items: center; }
.badge-count { font-size: 11px; font-weight: 500; color: #64748b; background: #f1f5f9; border-radius: 999px; padding: 2px 10px; margin-left: 10px; }

.table-wrapper { 
  padding-bottom: 30px; 
  overflow-x: auto; 
  -webkit-overflow-scrolling: touch; 
}

.nf-table { width: 100%; min-width: 900px; border-collapse: collapse; font-size: 12px; }
.nf-table thead th {
  background: #f8fafc;
  padding: 10px 1rem;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #e2e8f0;
}
.nf-table tbody td {
  padding: 5px 0.5rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.nf-table tbody tr:hover { background: #f8fafc; }
.row--cancelada td { background-color: #f9e9e980; }

.td-bold { font-weight: 600; color: #0f172a; }
.td-right, .th-right { text-align: right; }

.th-status { width: 110px; }

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}
.status-badge--cancelada { background: #ef44441a; color: #991b1b; border: 1px solid #fecaca; }
.status-badge--info { background: #e0f2fe; color: #0284c7; border: 1px solid #bae6fd; font-size: 10px; padding: 2px 8px; }

</style>
